import { GetStaticProps } from 'next';

import { REVALIDATE } from '~/constants/revalidate';
import { MarketingLayout, MarketingLayoutProps } from '~/layouts/MarketingLayout';
import { getPageBySlug } from '~/lib/contentful/api/page';
import { PageData } from '~/lib/contentful/custom-types';
import { heroRenderer } from '~/old-marketing/utils/heroRenderer';
import { sectionRenderer } from '~/old-marketing/utils/sectionRenderer';

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const { layoutSettings, seo, ...worthlessStudiosPage } = await getPageBySlug(
    !!preview,
    '/customers/worthless-studios',
  );

  return {
    props: {
      worthlessStudiosPage,
      layout: {
        ...layoutSettings,
        id: worthlessStudiosPage?.id ?? null,
        preview: !!preview,
        seo,
      },
    },
    revalidate: REVALIDATE,
  };
};

export default function WorthlessStudiosPage({
  worthlessStudiosPage,
}: { worthlessStudiosPage: PageData } & MarketingLayoutProps) {
  return (
    <>
      {heroRenderer(worthlessStudiosPage?.hero)}
      {worthlessStudiosPage?.sections?.map((section, index) => sectionRenderer(section, index, false))}
    </>
  );
}

WorthlessStudiosPage.layout = MarketingLayout;
